import { FC } from 'react';

import sharesTransferExcelModalSteps from '../constants/sharesTransferExcelModalSteps';
import { useSharesTransferExcelModal } from '../context/SharesTransferExcelModalContext';
import SharesTransferExcelUploadView from './SharesTransferExcelUploadView';
import SharesTransferExcelPreview from './SharesTransferExcelPreview';

const SharesTransferExcelModalBody: FC = () => {
  const { data } = useSharesTransferExcelModal();

  if (data.step === sharesTransferExcelModalSteps.PREVIEW) {
    return <SharesTransferExcelPreview />;
  }

  return <SharesTransferExcelUploadView />;
};

export default SharesTransferExcelModalBody;
